<mdb-form-control [formGroup]="formGroup">
  <textarea mdbInput
    id="{{id}}"
    class="form-control"
    rows="{{rows}}"
    [placeholder]="placeholder ?? '' | translate"
  formControlName="{{controlName}}"></textarea>
  <label mdbLabel
    class="form-label"
    for="{{id}}">{{ label|translate }} @if (isRequired) {
    <span>*</span>
  }</label>
  @if (isRequired && control?.hasError('required') && (control?.dirty || control?.touched)) {
    <mdb-error style="top: initial !important;">{{ label | translate }} ist
      erforderlich.
    </mdb-error>
  }
</mdb-form-control>
